import React from "react";

import classnames from "classnames";
import { updateQuotePageNavigation } from "EmployerApplication/api";
import { requestDentalPlans, setFilter } from "QuotePage/Actions";
import NeedMedicalModal from "QuotePage/app/DentalQuotePage/NeedMedicalModal";
import { quotePageURL } from "QuotePage/urls";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import { Modal, ModalBody, ModalFooter, ModalHeader, useModal } from "Cobalt/Modal";
import Button from "Common/Button";
import { Card } from "Common/Card/";
import { getRecommendedDentalPlans, addPlanToCart } from "Common/CartService";
import { isLoadingDentalPlans, getCartMedicalPlanIds } from "Common/CartService/Selectors";
import { LoadingContainer } from "Common/LoadingContainer";
import { appendAuthParams } from "Common/TokenAuth/Utils";

import AncillaryPlanCard from "./AncillaryPlanCard";

import makeBem from "Utils/makeBem";

const bem = makeBem("AddAncillaryPlanModal");

export default function AddDentalModalDumb({ show, onHide, onShow, plans, isLoading, addPlanToCart, medicalPlanSelected, viewAllDentalPlans }) {
  const { isShowing: isNeedMedicalModalShowing, show: showNeedMedicalModal, hide: hideNeedMedicalModal } = useModal();

  const openModal = () => {
    AnalyticsTracking.trackEvent("viewed_need_medical_modal", {});
    showNeedMedicalModal();
  };

  let planItems = (plans || []).map((plan) => <AncillaryPlanCard key={plan.id} plan={plan} addPlanToCart={medicalPlanSelected ? addPlanToCart : openModal} />);

  if (isLoading) {
    planItems = <LoadingContainer />;
  } else if (planItems.length === 0) {
    planItems = (
      <Card theme="elevated" className="plan-card loading">
        <div>We're busy uploading these plans. Please check back later.</div>
      </Card>
    );
  }

  const handleViewAllPlans = () => {
    AnalyticsTracking.trackEvent("view_all_dental_plans_clicked", {});
    if (!window.location.href.includes("select-plan")) {
      viewAllDentalPlans();
      updateQuotePageNavigation("dental_plans");

      setTimeout(() => {
        window.location = appendAuthParams(quotePageURL());
      }, 200);
    } else {
      viewAllDentalPlans();
    }
    onHide();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        className={bem()}
        onShow={() => {
          onShow(plans);
        }}
      >
        <ModalHeader closeButton>
          <TitleSmall mb={0} mt={0}>
            Add Dental
          </TitleSmall>
        </ModalHeader>
        <ModalBody className={bem("body")}>{planItems}</ModalBody>
        <ModalFooter>
          <Button size="medium" color="gray" className={classnames("full-dental-page")} onClick={handleViewAllPlans}>
            View All Plans
          </Button>
        </ModalFooter>
      </Modal>
      <NeedMedicalModal show={isNeedMedicalModalShowing} onHide={hideNeedMedicalModal} />
    </>
  );
}

const mapStateToProps = (state) => ({
  plans: getRecommendedDentalPlans(state).filter((plan) => plan.recommended),
  medicalPlanSelected: getCartMedicalPlanIds(state)?.length > 0,
  isLoading: isLoadingDentalPlans(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addPlanToCart: ({ planType, plan }) => {
    AnalyticsTracking.trackEvent("plan_added_to_cart", {
      plan_id: plan.id,
      type: planType,
    });

    AnalyticsTracking.trackEvent("checked_outcart_select_dental", {});

    dispatch(addPlanToCart({ planType, plan }));
    ownProps.onHide();
  },
  onShow: () => {
    dispatch(requestDentalPlans());
  },
  viewAllDentalPlans: () => {
    dispatch(setFilter("recommendation_mode", "dental_plans"));
  },
});

export const AddDentalModal = connect(mapStateToProps, mapDispatchToProps)(AddDentalModalDumb);
